import { Form } from '@ant-design/compatible';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncSimpleModal } from '../../lib/common';
import { versionActions } from '../../store/modules/version';
import VersionDetailWrap from '../../views/version/detail/VersionDetailWrap';
import { VERSION_DETAIL_MODEL } from '../../store/modules/version/model';

class VersionDetailContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  버전 데이터 초기화
   */
  initiate = () => {
    const { setData } = this.props;

    setData({
      path: ['versionDetail'],
      value: VERSION_DETAIL_MODEL,
    });
  };

  /**
   *  버전 등록/편집 하기
   */
  onSubmit = () => {
    const { form, versionDetail, onSubmit } = this.props;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) {
        return;
      }

      const { versionId, verType, verInfo } = versionDetail;
      const { serviceVer, code, forceUpdate, milestone, sprint, marketRegisterDate, releaseDate, jiraUrl, memo } =
        verInfo;

      onSubmit({
        versionId,
        verInfo: {
          ...verType,
          serviceVer,
          code,
          forceUpdate,
          milestone,
          sprint,
          marketRegisterDate,
          releaseDate,
          jiraUrl,
          memo,
        },
      });
    });
  };

  /**
   *  버전 삭제하기
   */
  deleteVersion = async () => {
    const { deleteVersion, versionDetail } = this.props;
    const { versionId } = versionDetail;

    const confirmDeleteVersion = await asyncSimpleModal({
      type: 'confirm',
      title: '버전 삭제하기',
      message: '정말 삭제하시겠습니까?',
    });

    if (!confirmDeleteVersion) return;

    deleteVersion({
      versionId,
    });
  };

  render() {
    const { form, versionDetail, setData, pageType } = this.props;

    return (
      <VersionDetailWrap
        pageType={pageType}
        onSubmit={this.onSubmit}
        deleteVersion={this.deleteVersion}
        isEditable={true}
        setData={setData}
        form={form}
        versionDetail={versionDetail}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    versionDetail: state.version.versionDetail,
  };
};

const mapDispatchToProps = {
  setData: versionActions.setData,
  deleteVersion: versionActions.deleteVersion,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(VersionDetailContainer));
